import React, { PropTypes } from 'react';
import { routerShape, withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { PrintButtonsToolbar, PrintLoadNextButton, PrintTable } from '@bibliocommons/print';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import Rating from '@bibliocommons/rating';
import './ShelfPrintList.scss';

function formatWithRatingsElement(results) {
  return results.map(item => item.get('currentUserRating') !== undefined ?
  item.set('currentUserRating', (
    <div className="shelf-owner-rating">
      <Rating
        id={`shelf-owner-rating-${item.get('metadataId')}`}
        type="blue"
        readOnly
        rating={item.get('currentUserRating')} />
    </div>
  )) : item.set('currentUserRating', null));
}

export class ShelfPrintList extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleUpdatePage');
  }

  handleUpdatePage() {
    const newPage = this.props.pagination.get('page') + 1;
    this.props.router.push(this.getHrefForPage(newPage));
  }

  getHrefForPage(page) {
    const { createHref, location } = this.props.router;
    return createHref({ ...location, query: { ...location.query, page } });
  }

  render() {
    const { pagination, results, isFetching, username, shelfName, loggedIn } = this.props;

    return (
      <div className="cp-shelf-print-list">
        <PrintButtonsToolbar numItemsToPrint={results.size}>
          <PrintLoadNextButton
            handleClick={this.handleUpdatePage}
            numToLoad={pagination.get('limit')}
            totalPages={pagination.get('pages')}
            currentPage={pagination.get('page')}
            isLoading={isFetching} />
        </PrintButtonsToolbar>
        <h1 className="page-header">
          <FormattedMessage id={`section_title_users_${shelfName}_shelf`} values={{ username }} />
        </h1>
        <p>
          <FormattedMessage id="label_number_of_items" values={{ count: pagination.get('count') }} />
        </p>
        <PrintTable
          rows={formatWithRatingsElement(results)}
          fields={[
            { key: 'title', type: 'item-title', headerKey: 'table_headings_title' },
            { key: 'authors', type: 'item-author', headerKey: 'table_headings_author' },
            { key: 'format', type: 'item-format', headerKey: 'table_headings_format', localizationMap: val => `FORMAT.${val.toLowerCase()}` },
            { key: 'currentUserRating', type: 'item-rating', headerKey: 'table_headings_rating' },
            { key: 'callNumber', type: 'item-call-number', headerKey: 'table_headings_call_number' }
          ]}
          hideColumnsWithNoData={!loggedIn} />
        <div className="page-info">
          <FormattedMessage id="form_label_current_page" values={{ current_page: pagination.get('page') }} />
          &nbsp;
          <FormattedMessage id="form_label_total_pages" values={{ total_pages: pagination.get('pages') }} />
        </div>
      </div>
    );
  }
}

ShelfPrintList.propTypes = {
  pagination: ImmutablePropTypes.map,
  results: ImmutablePropTypes.list,
  isFetching: PropTypes.bool,
  username: ImmutablePropTypes.string,
  shelfName: ImmutablePropTypes.string,
  router: routerShape.isRequired,
  loggedIn: PropTypes.bool
};

export default withRouter(ShelfPrintList);



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfPrintList/ShelfPrintList.jsx